export default {
  data() {
    return {
      siteOptions: [
        /**
         * SITE
         */
        {
          name: 'search',
          label: 'Top Nav - Search',
          storePath: 'site/options@topNav.show.search',
        },
        {
          name: 'uploadVideo',
          label: 'Top Nav - Upload Video',
          storePath: 'site/options@topNav.show.uploadVideo',
        },
        {
          name: 'notifications',
          label: 'Top Nav - Notifications',
          storePath: 'site/options@topNav.show.notifications',
        },
        {
          name: 'messages',
          label: 'Top Nav - Messages',
          storePath: 'site/options@topNav.show.messages',
        },
        /**
         * VIDEO LIST
         */
        {
          name: 'placeholders',
          label: 'Video List - Use Thumbnail Placeholders',
          storePath: 'site/options@videos.show.placeholders',
        },
        {
          name: 'duration',
          label: 'Video List - Duration',
          storePath: 'site/options@videos.show.duration',
        },
        {
          name: 'title',
          label: 'Video List - Title',
          storePath: 'site/options@videos.show.title',
        },
        {
          name: 'tags',
          label: 'Video List - Tags',
          storePath: 'site/options@videos.show.tags',
        },
        {
          name: 'views',
          label: 'Video List - Views',
          storePath: 'site/options@videos.show.views',
        },
        {
          name: 'date',
          label: 'Video List - Date',
          storePath: 'site/options@videos.show.date',
        },
        {
          name: 'timeAgo',
          label: 'Video List - Time Ago',
          storePath: 'site/options@videos.show.timeAgo',
        },
        {
          name: 'optionsDropdown',
          label: 'Video List - Options Dropdown',
          storePath: 'site/options@videos.show.optionsDropdown',
        },
        /**
         * VIDEO PAGE
         */
        {
          name: 'ads',
          label: 'Video Page - Ads',
          storePath: 'site/options@video.show.page.ads',
        },
        {
          name: 'channel',
          label: 'Video Page - Channel',
          storePath: 'site/options@video.show.page.channel',
        },
        {
          name: 'playlist',
          label: 'Video Page - Playlist',
          storePath: 'site/options@video.show.page.playlist',
        },
        {
          name: 'suggested',
          label: 'Video Page - Suggested',
          storePath: 'site/options@video.show.page.suggested',
        },
        {
          name: 'comments',
          label: 'Video Page - Comments',
          storePath: 'site/options@video.show.page.comments',
        },
        // {
        //   name: 'thumbnail',h
        //   label: 'Video - Thumbnail',
        //   storePath: 'site/options@video.show.video.thumbnail',
        // },
        {
          name: 'title',
          label: 'Video Page - Video - Title',
          storePath: 'site/options@video.show.video.title',
        },
        {
          name: 'description',
          label: 'Video Page - Video - Description',
          storePath: 'site/options@video.show.video.description',
        },
        {
          name: 'tags',
          label: 'Video Page - Video - Tags',
          storePath: 'site/options@video.show.video.tags',
        },
      ],
    };
  },
};
